import script from "./ProgramDetailOverview.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProgramDetailOverview.vue?vue&type=script&setup=true&lang=ts"

import "./ProgramDetailOverview.vue?vue&type=style&index=0&id=3a50f285&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a50f285"]])

export default __exports__